import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bb742ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-20 p-sm-25 p-md-30 p-lg-35 letter-spacing" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-16 text-uppercase fw-medium text-dark-emphasis" }, " Suggested System Data ", -1))
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1))
const _hoisted_7 = {
  class: "dropdown-menu dropdown-menu-end",
  ref: "dropdownMenu"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_10 = { class: "d-flex justify-content-between mb-3" }
const _hoisted_11 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Value Toggle"
}
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = {
  class: "table table-striped table-hover",
  id: "suggestedSystemTable"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Suggested System"),
    /*#__PURE__*/_createElementVNode("th", null, "SKU Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Volume In Stock"),
    /*#__PURE__*/_createElementVNode("th", null, "Volume Per Day")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTable('jpg')))
              }, [
                _hoisted_8,
                _createTextVNode(" Export as JPG ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportTable('png')))
              }, [
                _hoisted_9,
                _createTextVNode(" Export as PNG ")
              ])
            ])
          ], 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.displayMode === 'values' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDisplayMode('values')))
          }, " Values ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.displayMode === 'percentages' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDisplayMode('percentages')))
          }, " Percentages ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.displayMode === 'both' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDisplayMode('both')))
          }, " Both ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTableData, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ backgroundColor: _ctx.getColor(item.originalIndex) }),
                    class: "legend-dot"
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(item.SuggestedSystem), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatData(item.SKUQuantity, item.SKUPercentage)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatData(item.VolumeInStock, item.VolumeInStockPercentage)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatData(item.VolumePerDay, item.VolumePerDayPercentage)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}